module.exports = __webpack_public_path__ + "media/images/country_flags/im-97237f2e7ec37991fd7564aa11f62d1c.png";